<template>
  <div>
    <loading-page v-if="loading"></loading-page>

    <default-page
        v-else-if="error"
        buttonText="Reload"
        :errorMessage="errorMessage"
        @button-clicked="fetchSettings"
    ></default-page>
    <div
        v-else
        :class="darkTheme ? 'pageBackground_dark' : 'pageBackground_light'"
    >
      <confirm-dialog
          :dialog="confirmDialog"
          @confirmation-event="confirmationEventFunction"
          @mutate-confirm-dialog="confirmationEvent($event)"
          :text="confirmationDialogText"
          :acceptButton="deletingUser ? 'delete' : 'Reset'"
          :title="deletingUser ? 'Delete User' : 'Reset Settings'"
      ></confirm-dialog>
      <v-dialog
          v-model="userDialog"
          width="750"
          transition="scroll-x-transition"
          overlay-color="grey darken-2"
          persistent
      >
        <v-card class="accent" style="max-width: 750px">
          <v-card-title
              style="
              background-color: #47bd96;
              color: white;
              letter-spacing: 0.03rem;
              height: 40px;
            "
              :style="
              $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
            "
          >{{ add ? "Add User" : "Edit User" }}
          </v-card-title
          >
          <v-form class="pt-8" ref="userForm" v-model="userFormValid">
            <v-row class="mx-2">
              <v-col
                  cols="12"
                  sm="6"
                  class="py-0"
                  v-for="field in userFields"
                  :key="field.text"
              >
                <v-select
                    v-if="field.type === 'selector'"
                    outlined
                    dense
                    :multiple="field.value === 'roles'"
                    :menu-props="{ offsetY: true }"
                    item-text="text"
                    :label="field.text"
                    v-model="currentUserEditing[field.value]"
                    :items="field.value === 'enabled' ? enableItems : userRoles"
                    :rules="field.value !== 'enabled' ? [rules.required] : []"
                >
                  <template v-slot:item="{ item }">
                    <p class="mb-0">{{ item.text }}</p>
                  </template>
                </v-select>
                <v-text-field
                    v-else
                    class="textFieldOverride small-icon"
                    dense
                    outlined
                    :disabled="edit && field.value === 'username'"
                    :hint="field.value === 'password' ? passwordHint : null"
                    :persistent-hint="edit"
                    :label="field.text"
                    @click:append="showPassword = !showPassword"
                    :type="
                    field.value === 'password' && showPassword
                      ? field.value
                      : 'text'
                  "
                    v-model="currentUserEditing[field.value]"
                    :rules="
                    field.value === 'email'
                      ? [rules.required, rules.email]
                      : add
                      ? [rules.required]
                      : []
                  "
                    :append-icon="
                    field.value === 'password'
                      ? showPassword
                        ? 'fas fa-eye-slash'
                        : 'fas fa-eye'
                      : ''
                  "
                ></v-text-field>
              </v-col>
            </v-row>
            <p v-if="newUserViolations.length" class="red--text ml-6 mb-2">
              {{ newUserViolations.length === 1 ? "Violation" : "Violations" }}
            </p>
            <ul v-if="newUserViolations.length">
              <li
                  v-for="violation in newUserViolations"
                  :key="violation"
                  class="red--text mx-6"
              >
                {{ violation }}
              </li>
            </ul>
          </v-form>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn text @click="userDialog = !userDialog">Cancel</v-btn>
            <v-btn color="primary" text @click="saveUser">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              rounded
              class="primary more-btn mt-1 mr-1"
              icon
              text
              dark
              width="28"
              height="28"
              @click="confirmDialog = true"
              v-on="isNotDesktop ? 0 : on"
          >
            <v-icon small style="font-size: 16px">fas fa-redo-alt</v-icon>
          </v-btn>
        </template>
        <span>Reset to Default</span>
      </v-tooltip>
      <v-tabs
          height="50"
          id="vTabsId"
          v-model="tabs"
          show-arrows
          centered
          :background-color="$vuetify.theme.dark ? '#262B2E' : '#fff'"
          class="v-tabs-customClass"
          slot="extension"
          center-active
          :slider-size="3"
          :hide-slider="true"
      >
        <v-tab
            v-if="$vuetify.breakpoint.xsOnly"
            style="height: 50px; margin-right: auto"
            class="vTabClassMobile tabs-border-bottom"
            active-class="selectedTab"
            :key="currentTabItem != null ? currentTabItem.id : 0"
        >{{ currentTabItem == null ? "No tab" : currentTabItem.name }}
        </v-tab
        >
        <v-menu
            v-if="$vuetify.breakpoint.xsOnly"
            transition="slide-y-transition"
            content-class="normal-menu"
            bottom
            left
        >
          <template v-slot:activator="{ on }">
            <v-btn icon text class="white--text more-btn" v-on="on">
              <span
                  style="
                  font-size: 28px;
                  margin-right: 2px;
                  letter-spacing: 0 !important;
                "
                  class="icon-more-21x21"
              >
                <span class="path1 letterSpacing0"></span>
                <span class="path2 letterSpacing0"></span>
                <span class="path3 letterSpacing0"></span>
                <span class="path4 letterSpacing0"></span>
              </span>
            </v-btn>
          </template>
          <div>
            <v-list dense>
              <v-list-item @click="confirmDialog = true">
                <v-list-item-action class="mr-5">
                  <v-icon style="font-size: 20px">fas fa-redo-alt</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 15px"
                  >Reset to Default
                  </v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list style="margin-top: 1px" dense>
              <v-list-item-title
                  style="font-size: 15px"
                  class="pl-4 pt-3 pb-2 font-weight-bold normal-bottom-border"
              >Settings
              </v-list-item-title
              >

              <v-list-item
                  v-for="(section, index) in settingsSections"
                  :key="section.name"
                  @click="addItem(section, index)"
              >
                <p
                    class="mb-1"
                    :class="
                    currentTabItem.id === section.id
                      ? 'primary--text-persist'
                      : 'supplementary-class'
                  "
                >
                  {{ section.name }}
                </p>
              </v-list-item>
            </v-list>
          </div>
        </v-menu>
        <v-tab
            v-else
            v-for="(section, index) in settingsSections"
            :key="section.name"
            class="vTabClass"
            active-class="selectedTab"
            @click="addItem(section, index)"
        >
          <v-icon
              medium
              left
              :style="((index === 2) || (index === 3)) ? 'font-size: 18px !important;' : 'opacity:1;'"
          >{{ section.icon }}
          </v-icon
          >
          {{ section.name }}
        </v-tab>
        <template v-if="isAdmin">
          <v-tab
              v-for="(section, index) in adminSettingsSections"
              :key="section.name"
              class="vTabClass"
              active-class="selectedTab"
              @click="addItem(section, index + settingsSections.length - 1)"
          >
            <v-icon
                medium
                left
                :style="'font-size: 18px !important;'"
            >{{ section.icon }}
            </v-icon
            >
            {{ section.name }}
          </v-tab>
        </template>
        <v-tabs-items
            :touchless="true"
            v-model="currentTabItem.id"
            :style="`overflow: hidden auto;height: ${windowSizeY - 105}px;`"
        >
          <v-tab-item :disabled="true" class="darkText dashboardTabItem">
            <v-row v-if="isAdmin" justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 30px"
              >
                <v-icon
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="font-size: 23px"
                    left
                >far fa-chart-bar
                </v-icon
                >
                Dashboard
              </h1>
            </v-row>
            <v-row v-if="isAdmin" justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="py-5 my-5 secondary-h1"
              >
                Dashboard Parameters
              </h2>
            </v-row>
            <v-form
                v-if="isAdmin"
                id="dashboardForm"
                :lazy-validation="false"
                ref="dashboardForm"
                v-model="valid"
            >
              <v-row justify="center">
                <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                  <v-text-field
                      class="settings-number-input"
                      id="dashboardurl"
                      dense
                      outlined
                      label="URL e.g http://analytics.dealio.ai"
                      :value="getFilteredSettings.general.dashboard.url"
                      :rules="[rules.url]"
                      @input="
                      ignoreInputChange
                        ? ''
                        : updateSetting(
                            ['general', 'dashboard', 'url'],
                            'dashboardurl',
                            rules.url
                          )
                    "
                  >
                    <template v-slot:append>
                      <v-progress-circular
                          class="saving-icon mt-1"
                          v-if="
                          fieldStatusIs('dashboardurl', getErrorEnums.LOADING)
                        "
                          size="16"
                          width="2"
                          dense
                          color="primary"
                          indeterminate
                      ></v-progress-circular>
                      <v-icon
                          v-else-if="
                          fieldStatusIs('dashboardurl', getErrorEnums.SAVED)
                        "
                          class="saving-icon-green mt-1"
                      >fas fa-check
                      </v-icon
                      >
                      <div
                          v-else-if="
                          fieldStatusIs('dashboardurl', getErrorEnums.DEFAULT)
                        "
                      ></div>
                      <v-icon v-else class="saving-icon-red mt-1"
                      >fas fa-times
                      </v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                  <v-text-field
                      class="settings-number-input"
                      id="dashboardsecret_key"
                      dense
                      outlined
                      label="Secret Key"
                      :value="getFilteredSettings.general.dashboard.secret_key"
                      @input="
                      ignoreInputChange
                        ? ''
                        : updateSetting(
                            ['general', 'dashboard', 'secret_key'],
                            'dashboardsecret_key'
                          )
                    "
                  >
                    <template v-slot:append>
                      <v-progress-circular
                          class="saving-icon mt-1"
                          v-if="
                          fieldStatusIs(
                            'dashboardsecret_key',
                            getErrorEnums.LOADING
                          )
                        "
                          size="16"
                          width="2"
                          dense
                          color="primary"
                          indeterminate
                      ></v-progress-circular>
                      <div
                          v-else-if="
                          fieldStatusIs(
                            'dashboardsecret_key',
                            getErrorEnums.DEFAULT
                          )
                        "
                      ></div>
                      <v-icon v-else class="saving-icon-green mt-1"
                      >fas fa-check
                      </v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                  <v-text-field
                      class="settings-number-input"
                      id="dashboardexp"
                      type="number"
                      dense
                      outlined
                      label="Expiration time (in seconds)"
                      :value="getFilteredSettings.general.dashboard.exp"
                      @input="
                      ignoreInputChange
                        ? ''
                        : updateSetting(
                            ['general', 'dashboard', 'exp'],
                            'dashboardexp',
                            rules.num
                          )
                    "
                      :rules="[rules.num]"
                  >
                    <template v-slot:append>
                      <v-progress-circular
                          class="saving-icon mt-1"
                          v-if="
                          fieldStatusIs('dashboardexp', getErrorEnums.LOADING)
                        "
                          size="16"
                          width="2"
                          dense
                          color="primary"
                          indeterminate
                      ></v-progress-circular>
                      <v-icon
                          v-else-if="
                          fieldStatusIs('dashboardexp', getErrorEnums.SAVED)
                        "
                          class="saving-icon-green mt-1"
                      >fas fa-check
                      </v-icon
                      >
                      <div
                          v-else-if="
                          fieldStatusIs('dashboardexp', getErrorEnums.DEFAULT)
                        "
                      ></div>
                      <v-icon v-else class="saving-icon-red mt-1"
                      >fas fa-times
                      </v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                  <v-text-field
                      class="settings-number-input"
                      id="dashboardrefresh_time"
                      type="number"
                      dense
                      outlined
                      label="Auto-refresh time (min 3 sec, default 15 sec)"
                      :value="getFilteredSettings.general.dashboard.refresh_time"
                      @input="
                      ignoreInputChange
                        ? ''
                        : updateSetting(
                            ['general', 'dashboard', 'refresh_time'],
                            'dashboardrefresh_time',
                            rules.min
                          )
                    "
                      :rules="[rules.min]"
                  >
                    <template v-slot:append>
                      <v-progress-circular
                          class="saving-icon mt-1"
                          v-if="
                          fieldStatusIs(
                            'dashboardrefresh_time',
                            getErrorEnums.LOADING
                          )
                        "
                          size="16"
                          width="2"
                          dense
                          color="primary"
                          indeterminate
                      ></v-progress-circular>
                      <v-icon
                          v-else-if="
                          fieldStatusIs(
                            'dashboardrefresh_time',
                            getErrorEnums.SAVED
                          )
                        "
                          class="saving-icon-green mt-1"
                      >fas fa-check
                      </v-icon
                      >
                      <div
                          v-else-if="
                          fieldStatusIs(
                            'dashboardrefresh_time',
                            getErrorEnums.DEFAULT
                          )
                        "
                      ></div>
                      <v-icon v-else class="saving-icon-red mt-1"
                      >fas fa-times
                      </v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                  <v-text-field
                      class="settings-number-input"
                      id="dashboardnumber"
                      type="number"
                      dense
                      outlined
                      label="Dashboard Number"
                      :value="getFilteredSettings.general.dashboard.number"
                      @input="
                      ignoreInputChange
                        ? ''
                        : updateSetting(
                            ['general', 'dashboard', 'number'],
                            'dashboardnumber',
                            rules.num
                          )
                    "
                      :rules="[rules.num]"
                  >
                    <template v-slot:append>
                      <v-progress-circular
                          class="saving-icon mt-1"
                          v-if="
                          fieldStatusIs(
                            'dashboardnumber',
                            getErrorEnums.LOADING
                          )
                        "
                          size="16"
                          width="2"
                          dense
                          color="primary"
                          indeterminate
                      ></v-progress-circular>
                      <v-icon
                          v-else-if="
                          fieldStatusIs('dashboardnumber', getErrorEnums.SAVED)
                        "
                          class="saving-icon-green mt-1"
                      >fas fa-check
                      </v-icon
                      >
                      <div
                          v-else-if="
                          fieldStatusIs(
                            'dashboardnumber',
                            getErrorEnums.DEFAULT
                          )
                        "
                      ></div>
                      <v-icon v-else class="saving-icon-red mt-1"
                      >fas fa-times
                      </v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                    cols="10"
                    xl="3"
                    lg="4"
                    md="4"
                    sm="5"
                    class="py-0"
                ></v-col>
              </v-row>
            </v-form>
            <v-row justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 30px"
              >
                <v-icon
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="font-size: 26px"
                    left
                >volume_up
                </v-icon
                >
                Sounds
              </h1>
            </v-row>
            <v-row justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="py-5 my-5 secondary-h1"
              >
                Customize sounds
              </h2>
            </v-row>

            <v-row justify="center">
              <v-col
                  v-if="$vuetify.breakpoint.xlAndUp"
                  cols="2"
                  xl="2"
                  md="0"
              ></v-col>
              <v-col class="pt-0" xl="3" lg="4" md="5" sm="8" cols="10">
                <h3
                    class="text-center"
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="padding-bottom: 20px"
                >
                  Available Sounds
                </h3>

                <v-data-table
                    :mobile-breakpoint="0"
                    id="soundsTable"
                    style="border: 1px solid #47bd96 !important"
                    class="accent dealio-table"
                    dense
                    height="210"
                    hide-default-footer
                    hide-default-header
                    :headers="[{ text: 'Sound' }, { text: 'Play/Use' }]"
                    :items="mp3Sounds"
                    fixed-header
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <p
                            class="mb-0"
                            style="
                            font-size: 16px;
                            margin-right: -70px;
                            margin-left: 70px;
                          "
                        >
                          {{ item }}
                        </p>
                      </td>
                      <td class="text-center">
                        <v-btn @click="$emit('play-sound', item)" icon>
                          <span style="font-size: 28px" class="icon-play-21x21">
                            <span class="path1 letterSpacing0"></span>
                            <span class="path2"></span>
                          </span>
                        </v-btn>

                        <v-menu style="margin-top: 12px" bottom right>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="alert-cation" icon>
                              <v-icon color="white" class="use-sound" style
                              >fas fa-sign-out-alt
                              </v-icon
                              >
                            </v-btn>
                          </template>
                          <v-list style="border: 1px solid #47bd96" dense>
                            <p
                                class="text-left pl-4 my-0"
                                style="background: #47bd96; color: white"
                            >
                              Choose an event
                            </p>
                            <template v-for="eventName in getEventNames">
                              <v-list-item
                                  :key="eventName.original"
                                  @click="useSoundAs(eventName.original, item)"
                                  style="border-top: 1px solid #47bd96"
                              >
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                      eventName.filtered
                                    }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                    <tr>
                      <th style="background: #47bd96; color: white">
                        <p class="text-center mb-0" style="font-size: 16px">
                          {{ headers[0].text }}
                        </p>
                      </th>
                      <th style="background: #47bd96; color: white">
                        <p class="text-center mb-0" style="font-size: 16px">
                          {{ headers[1].text }}
                        </p>
                      </th>
                    </tr>
                    </thead>
                  </template>
                </v-data-table>
              </v-col>
              <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1"></v-col>
              <v-col class="pt-0" xl="3" lg="4" md="5" sm="8" cols="10">
                <h3
                    class="text-center"
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="padding-bottom: 20px"
                >
                  Available Events
                </h3>
                <v-data-table
                    :mobile-breakpoint="0"
                    id="eventsTable"
                    style="border: 1px solid #47bd96 !important"
                    class="accent dealio-table"
                    dense
                    height="210"
                    hide-default-footer
                    hide-default-header
                    :headers="[
                    { text: 'Event', value: 'event' },
                    { text: 'Sound', value: 'sound' },
                  ]"
                    :items="getAvailableEvents"
                    fixed-header
                >
                  <template v-slot:item="{ item }">
                    <tr style="height: 37px">
                      <td>
                        <p
                            class="mb-0"
                            :class="
                            $vuetify.breakpoint.xsOnly
                              ? 'eventItemsXS'
                              : 'eventItems'
                          "
                        >
                          {{ item.event }}
                        </p>
                      </td>
                      <td>
                        <p
                            class="mb-0"
                            :class="
                            $vuetify.breakpoint.xsOnly
                              ? 'soundItemsXS'
                              : 'soundItems'
                          "
                        >
                          {{ item.sound }}
                        </p>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                    <tr>
                      <th style="background: #47bd96; color: white">
                        <p class="text-center mb-0" style="font-size: 16px">
                          {{ headers[0].text }}
                        </p>
                      </th>
                      <th style="background: #47bd96; color: white">
                        <p class="text-center mb-0" style="font-size: 16px">
                          {{ headers[1].text }}
                        </p>
                      </th>
                    </tr>
                    </thead>
                  </template>
                </v-data-table>
              </v-col>
              <v-col v-if="$vuetify.breakpoint.xlAndUp" cols="2" xl="2"></v-col>
            </v-row>
            <v-row justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 30px"
              >
                <v-icon
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="font-size: 20px"
                    left
                >fas fa-paint-brush
                </v-icon
                >
                Appearance
              </h1>
            </v-row>
            <v-row justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="py-5 my-5 secondary-h1"
              >
                Display Mode
              </h2>
            </v-row>
            <v-row justify="center">
              <mode-picker/>
            </v-row>
            <v-row justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 50px"
              >
                <v-icon
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="font-size: 19px"
                    left
                >icon-new-notification-24x24
                </v-icon
                >
                Notifications
              </h1>
            </v-row>
            <v-row justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="mt-10 mb-5 secondary-h1"
              >
                Device notifications
              </h2>
            </v-row>
            <v-row justify="center" class="my-2">
              <v-row
                  justify="space-between"
                  class="settings-switch-row pt-2"
                  style="border-top: 1px solid rgb(255, 255, 255, 0.2)"
              >
                <p
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  Enable
                </p>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="enableNotifications"
                      v-model="enableNotifications"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="
                      fieldStatusIs(
                        'enableNotifications',
                        getErrorEnums.LOADING
                      )
                    "
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="
                      fieldStatusIs('enableNotifications', getErrorEnums.SAVED)
                    "
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="
                      fieldStatusIs(
                        'enableNotifications',
                        getErrorEnums.DEFAULT
                      )
                    "
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
            </v-row>
            <v-row justify="center" class="my-2">
              <v-row
                  id="overwrite-notifications"
                  class="settings-switch-row"
                  justify="space-between"
              >
                <div
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  Update same type notifications
                  <div
                      :class="darkTheme ? 'lightText' : 'darkText2'"
                      style="
                      float: right;
                      margin-top: 5px;
                      margin-left: 5px;
                      font-size: 11px;
                    "
                  >
                    (Mobile)
                  </div>
                </div>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="updateSameTypeNotifications"
                      v-model="updateSameTypeNotifications"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="
                      fieldStatusIs(
                        'updateSameTypeNotifications',
                        getErrorEnums.LOADING
                      )
                    "
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="
                      fieldStatusIs(
                        'updateSameTypeNotifications',
                        getErrorEnums.SAVED
                      )
                    "
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="
                      fieldStatusIs(
                        'updateSameTypeNotifications',
                        getErrorEnums.DEFAULT
                      )
                    "
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
              <v-tooltip
                  activator="#overwrite-notifications"
                  :disabled="isNotDesktop"
                  class="mt-3 ml-1"
                  content-class="tooltipClassBottom"
                  bottom
              >
                <span
                >When enabled, notifications of the same type will overwrite
                  each other.<br/>E.g if you receive a Price Guard event twice,
                  the first notification will be<br/>overwritten by the second
                  one and you will only see the second notification.
                </span>
              </v-tooltip>
            </v-row>
            <v-row justify="center" class="my-2">
              <v-row
                  id="renotify"
                  class="settings-switch-row"
                  justify="space-between"
              >
                <div
                    :class="{
                    lightText: darkTheme,
                    darkText2: !darkTheme,
                    'grey--text': !updateSameTypeNotifications,
                  }"
                    class="ml-4 mb-0"
                >
                  Re-notify
                  <div
                      :class="{
                      lightText: darkTheme,
                      darkText2: !darkTheme,
                      'grey--text': !updateSameTypeNotifications,
                    }"
                      style="
                      float: right;
                      margin-top: 5px;
                      margin-left: 5px;
                      font-size: 11px;
                    "
                  >
                    (Mobile)
                  </div>
                </div>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="renotify"
                      v-model="renotify"
                      :disabled="!updateSameTypeNotifications"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="fieldStatusIs('renotify', getErrorEnums.LOADING)"
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="fieldStatusIs('renotify', getErrorEnums.SAVED)"
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="fieldStatusIs('renotify', getErrorEnums.DEFAULT)"
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
              <v-tooltip
                  activator="#renotify"
                  :disabled="isNotDesktop"
                  class="mt-3 ml-1"
                  content-class="tooltipClassBottom"
                  bottom
              >
                <span
                >When enabled, overwritten notifications will play a
                  sound.</span
                >
              </v-tooltip>
            </v-row>
            <v-row justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="mt-10 mb-5 secondary-h1"
              >
                In-app notifications
              </h2>
            </v-row>
            <v-row justify="center" class="my-2">
              <v-row
                  justify="space-between"
                  class="settings-switch-row pt-2"
                  style="border-top: 1px solid rgb(255, 255, 255, 0.2)"
              >
                <p
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  Stack notifications
                </p>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="stackNotifications"
                      v-model="stackNotifications"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="
                      fieldStatusIs('stackNotifications', getErrorEnums.LOADING)
                    "
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="
                      fieldStatusIs('stackNotifications', getErrorEnums.SAVED)
                    "
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="
                      fieldStatusIs('stackNotifications', getErrorEnums.DEFAULT)
                    "
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
            </v-row>
            <h3
                class="text-center settings-text mt-10"
                style="font-weight: 500"
            >
              Device notifications to show:
              <a
                  href="https://dealio.ai/docs/en/ui/ui-structure-and-features/#alerts--notifications"
                  target="_blank"
              >
                <i style="font-size: 17px" class="far fa-question-circle"></i>
              </a>
            </h3>
            <v-row
                justify="center"
                :class="{ 'notif-show': $vuetify.breakpoint.lg }"
            >
              <v-col
                  cols="12"
                  xl="1"
                  md="2"
                  sm="3"
                  :class="{ 'py-0': $vuetify.breakpoint.xsOnly }"
              >
                <v-row
                    justify="center"
                    :class="{ 'ml-1': $vuetify.breakpoint.xsOnly }"
                >
                  <v-checkbox
                      id="notificationssuccess"
                      :style="{ 'width: 93px;': $vuetify.breakpoint.xsOnly }"
                      off-icon="far fa-check-circle"
                      on-icon="fas fa-check-circle"
                      label="Success"
                      class="checkbox-md"
                      v-model="notificationssuccess"
                  ></v-checkbox>
                  <v-col cols="2" class="pt-4">
                    <v-progress-circular
                        class="saving-icon mt-1"
                        v-if="
                        fieldStatusIs(
                          'notificationssuccess',
                          getErrorEnums.LOADING
                        )
                      "
                        size="16"
                        width="2"
                        dense
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    <v-icon
                        v-else-if="
                        fieldStatusIs(
                          'notificationssuccess',
                          getErrorEnums.SAVED
                        )
                      "
                        class="saving-icon-green mt-1"
                    >fas fa-check
                    </v-icon
                    >
                    <div
                        v-else-if="
                        fieldStatusIs(
                          'notificationssuccess',
                          getErrorEnums.DEFAULT
                        )
                      "
                    ></div>
                    <v-icon v-else class="saving-icon-red mt-1"
                    >fas fa-times
                    </v-icon
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                  cols="12"
                  xl="1"
                  md="2"
                  sm="3"
                  :class="{ 'py-0': $vuetify.breakpoint.xsOnly }"
              >
                <v-row
                    justify="center"
                    :class="{ 'ml-1': $vuetify.breakpoint.xsOnly }"
                >
                  <v-checkbox
                      id="notificationsinfo"
                      :style="{ 'width: 93px;': $vuetify.breakpoint.xsOnly }"
                      off-icon="far fa-check-circle"
                      on-icon="fas fa-check-circle"
                      label="Info"
                      class="checkbox-md"
                      v-model="notificationsinfo"
                  ></v-checkbox>
                  <v-col cols="2" class="pt-4">
                    <v-progress-circular
                        class="saving-icon mt-1"
                        v-if="
                        fieldStatusIs(
                          'notificationsinfo',
                          getErrorEnums.LOADING
                        )
                      "
                        size="16"
                        width="2"
                        dense
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    <v-icon
                        v-else-if="
                        fieldStatusIs('notificationsinfo', getErrorEnums.SAVED)
                      "
                        class="saving-icon-green mt-1"
                    >fas fa-check
                    </v-icon
                    >
                    <div
                        v-else-if="
                        fieldStatusIs(
                          'notificationsinfo',
                          getErrorEnums.DEFAULT
                        )
                      "
                    ></div>
                    <v-icon v-else class="saving-icon-red mt-1"
                    >fas fa-times
                    </v-icon
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                  cols="12"
                  xl="1"
                  md="2"
                  sm="3"
                  :class="{ 'py-0': $vuetify.breakpoint.xsOnly }"
              >
                <v-row
                    justify="center"
                    :class="{ 'ml-1': $vuetify.breakpoint.xsOnly }"
                >
                  <v-checkbox
                      id="notificationserror"
                      off-icon="far fa-check-circle"
                      on-icon="fas fa-check-circle"
                      label="Error"
                      class="checkbox-md"
                      v-model="notificationserror"
                  ></v-checkbox>

                  <v-col cols="2" class="pt-4">
                    <v-progress-circular
                        class="saving-icon mt-1"
                        v-if="
                        fieldStatusIs(
                          'notificationserror',
                          getErrorEnums.LOADING
                        )
                      "
                        size="16"
                        width="2"
                        dense
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    <v-icon
                        v-else-if="
                        fieldStatusIs('notificationserror', getErrorEnums.SAVED)
                      "
                        class="saving-icon-green mt-1"
                    >fas fa-check
                    </v-icon
                    >
                    <div
                        v-else-if="
                        fieldStatusIs(
                          'notificationserror',
                          getErrorEnums.DEFAULT
                        )
                      "
                    ></div>
                    <v-icon v-else class="saving-icon-red mt-1"
                    >fas fa-times
                    </v-icon
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                  cols="12"
                  xl="1"
                  md="2"
                  sm="3"
                  :class="{ 'py-0': $vuetify.breakpoint.xsOnly }"
              >
                <v-row
                    justify="center"
                    :class="{ 'ml-1': $vuetify.breakpoint.xsOnly }"
                >
                  <v-checkbox
                      id="notificationswarning"
                      :style="{
                      'width: 93px !important;': $vuetify.breakpoint.xsOnly,
                    }"
                      off-icon="far fa-check-circle"
                      on-icon="fas fa-check-circle"
                      label="Warning"
                      class="checkbox-md"
                      v-model="notificationswarning"
                  ></v-checkbox>
                  <v-col cols="2" class="pt-4">
                    <v-progress-circular
                        class="saving-icon mt-1"
                        v-if="
                        fieldStatusIs(
                          'notificationswarning',
                          getErrorEnums.LOADING
                        )
                      "
                        size="16"
                        width="2"
                        dense
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    <v-icon
                        v-else-if="
                        fieldStatusIs(
                          'notificationswarning',
                          getErrorEnums.SAVED
                        )
                      "
                        class="saving-icon-green mt-1"
                    >fas fa-check
                    </v-icon
                    >
                    <div
                        v-else-if="
                        fieldStatusIs(
                          'notificationswarning',
                          getErrorEnums.DEFAULT
                        )
                      "
                    ></div>
                    <v-icon v-else class="saving-icon-red mt-1"
                    >fas fa-times
                    </v-icon
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="isAdmin" justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 30px"
              >
                <!-- <v-icon
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="font-size: 25px;"
                  left
                  >fab fa-mixcloud</v-icon
                > -->
                Other
              </h1>
            </v-row>
            <v-row v-if="isAdmin" justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="py-5 my-5 secondary-h1"
              >
                Server Sent Events
              </h2>
            </v-row>
            <v-row v-if="isAdmin" justify="center">
              <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                <v-text-field
                    class="settings-number-input"
                    id="ssepingAbsenceLimit"
                    type="number"
                    dense
                    outlined
                    label="Ping absence limit (ms)"
                    :value="getFilteredSettings.general.sse.pingAbsenceLimit"
                    @input="
                    ignoreInputChange
                      ? ''
                      : updateSetting(
                          ['general', 'sse', 'pingAbsenceLimit'],
                          'ssepingAbsenceLimit',
                          rules.num
                        )
                  "
                    :rules="[rules.num]"
                >
                  <template v-slot:append>
                    <v-progress-circular
                        class="saving-icon mt-1"
                        v-if="
                        fieldStatusIs(
                          'ssepingAbsenceLimit',
                          getErrorEnums.LOADING
                        )
                      "
                        size="16"
                        width="2"
                        dense
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    <v-icon
                        v-else-if="
                        fieldStatusIs(
                          'ssepingAbsenceLimit',
                          getErrorEnums.SAVED
                        )
                      "
                        class="saving-icon-green mt-1"
                    >fas fa-check
                    </v-icon
                    >
                    <div
                        v-else-if="
                        fieldStatusIs(
                          'ssepingAbsenceLimit',
                          getErrorEnums.DEFAULT
                        )
                      "
                    ></div>
                    <v-icon v-else class="saving-icon-red mt-1"
                    >fas fa-times
                    </v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="isAdmin" class="pb-5 mb-5 mt-2" justify="center">
              <v-row
                  justify="space-between"
                  class="settings-switch-row pt-2"
                  style="border-top: 1px solid rgb(255, 255, 255, 0.2)"
              >
                <p
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  SSE State Logging
                </p>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="logSSEState"
                      v-model="logSSEState"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="fieldStatusIs('logSSEState', getErrorEnums.LOADING)"
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="
                      fieldStatusIs('logSSEState', getErrorEnums.SAVED)
                    "
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="
                      fieldStatusIs('logSSEState', getErrorEnums.DEFAULT)
                    "
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
            </v-row>
          </v-tab-item>
          <v-tab-item class="darkText">
            <v-row justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 30px"
              >
                <v-icon :class="darkTheme ? 'title_dark' : 'title_light'" left
                >icon-price-guard-21x25
                </v-icon
                >
                Price Guard
              </h1>
            </v-row>
            <v-row justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="pt-5 mt-5 secondary-h1"
              >
                Status & Timing
              </h2>
            </v-row>

            <v-row justify="center" class="pt-5 mt-5" id="text-fields">
              <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                <v-text-field
                    dense
                    id="priceguardpriceOldAfter"
                    type="number"
                    outlined
                    class="rm-number-arrows settings-number-input"
                    label="Price aging time (old):"
                    :value="
                    getFilteredSettings.applications.priceguard.priceOldAfter
                  "
                    @input="
                    ignoreInputChange
                      ? ''
                      : updateSetting(
                          ['applications', 'priceguard', 'priceOldAfter'],
                          'priceguardpriceOldAfter',
                          rules.num
                        )
                  "
                    height="20"
                    :rules="[rules.num]"
                >
                  <template v-slot:append>
                    <v-row>
                      <v-col cols="6" style="max-width: 24px" class="py-0 mr-3">
                        <v-progress-circular
                            class="saving-icon mt-1"
                            v-if="
                            fieldStatusIs(
                              'priceguardpriceOldAfter',
                              getErrorEnums.LOADING
                            )
                          "
                            size="16"
                            width="2"
                            dense
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                        <v-icon
                            v-else-if="
                            fieldStatusIs(
                              'priceguardpriceOldAfter',
                              getErrorEnums.SAVED
                            )
                          "
                            class="saving-icon-green mt-1"
                        >fas fa-check
                        </v-icon
                        >
                        <div
                            v-else-if="
                            fieldStatusIs(
                              'priceguardpriceOldAfter',
                              getErrorEnums.DEFAULT
                            )
                          "
                        ></div>
                        <v-icon v-else class="saving-icon-red mt-1"
                        >fas fa-times
                        </v-icon
                        >
                      </v-col>
                      <v-col cols="4" class="py-0 mr-1">
                        <v-row justify="start">
                          <v-tooltip
                              max-width="300"
                              bottom
                              content-class="text-center"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" class="pt-1"
                              >far fa-question-circle
                              </v-icon
                              >
                            </template>
                            <span class="text-center">
                              Time in seconds (from when a price matched the
                              rule) after which it is considered old. Default:
                              30sec
                            </span>
                          </v-tooltip>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                <v-text-field
                    dense
                    outlined
                    label="Price expiration time:"
                    id="priceguarddataExpirationCycle"
                    type="number"
                    :value="
                    getFilteredSettings.applications.priceguard
                      .dataExpirationCycle
                  "
                    @input="
                    ignoreInputChange
                      ? ''
                      : updateSetting(
                          ['applications', 'priceguard', 'dataExpirationCycle'],
                          'priceguarddataExpirationCycle',
                          rules.num
                        )
                  "
                    height="20"
                    color="primary"
                    class="text-field rm-number-arrows settings-number-input"
                    :rules="[rules.num]"
                >
                  <template v-slot:append>
                    <v-row>
                      <v-col cols="6" style="max-width: 24px" class="py-0 mr-3">
                        <v-progress-circular
                            class="saving-icon mt-1"
                            v-if="
                            fieldStatusIs(
                              'priceguarddataExpirationCycle',
                              getErrorEnums.LOADING
                            )
                          "
                            size="16"
                            width="2"
                            dense
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                        <v-icon
                            v-else-if="
                            fieldStatusIs(
                              'priceguarddataExpirationCycle',
                              getErrorEnums.SAVED
                            )
                          "
                            class="saving-icon-green mt-1"
                        >fas fa-check
                        </v-icon
                        >
                        <div
                            v-else-if="
                            fieldStatusIs(
                              'priceguarddataExpirationCycle',
                              getErrorEnums.DEFAULT
                            )
                          "
                        ></div>
                        <v-icon v-else class="saving-icon-red mt-1"
                        >fas fa-times
                        </v-icon
                        >
                      </v-col>
                      <v-col cols="4" class="py-0 mr-1">
                        <v-row justify="start">
                          <v-tooltip
                              max-width="300"
                              bottom
                              content-class="text-center"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" class="pt-1"
                              >far fa-question-circle
                              </v-icon
                              >
                            </template>
                            <span class="text-center">
                              Time in seconds (from when a price stopped
                              matching the rule) after which it is considered
                              expired. Default: 30sec
                            </span>
                          </v-tooltip>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" id="text-fields">
              <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0">
                <v-text-field
                    dense
                    outlined
                    label="Expired price removal:"
                    id="priceguardremoveExpiredDataAfter"
                    type="number"
                    :value="
                    getFilteredSettings.applications.priceguard
                      .removeExpiredDataAfter
                  "
                    @input="
                    ignoreInputChange
                      ? ''
                      : updateSetting(
                          [
                            'applications',
                            'priceguard',
                            'removeExpiredDataAfter',
                          ],
                          'priceguardremoveExpiredDataAfter',
                          rules.num
                        )
                  "
                    height="20"
                    color="primary"
                    class="text-field rm-number-arrows settings-number-input"
                    :rules="[rules.num, rules.min]"
                >
                  <template v-slot:append>
                    <v-row>
                      <v-col cols="6" style="max-width: 24px" class="py-0 mr-3">
                        <v-progress-circular
                            class="saving-icon mt-1"
                            v-if="
                            fieldStatusIs(
                              'priceguardremoveExpiredDataAfter',
                              getErrorEnums.LOADING
                            )
                          "
                            size="16"
                            width="2"
                            dense
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                        <v-icon
                            v-else-if="
                            fieldStatusIs(
                              'priceguardremoveExpiredDataAfter',
                              getErrorEnums.SAVED
                            )
                          "
                            class="saving-icon-green mt-1"
                        >fas fa-check
                        </v-icon
                        >
                        <div
                            v-else-if="
                            fieldStatusIs(
                              'priceguardremoveExpiredDataAfter',
                              getErrorEnums.DEFAULT
                            )
                          "
                        ></div>
                        <v-icon v-else class="saving-icon-red mt-1"
                        >fas fa-times
                        </v-icon
                        >
                      </v-col>
                      <v-col cols="4" class="py-0 mr-1">
                        <v-row justify="start">
                          <v-tooltip
                              max-width="300"
                              bottom
                              content-class="text-center"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" class="pt-1"
                              >far fa-question-circle
                              </v-icon
                              >
                            </template>
                            <span class="text-center">
                              Time in seconds after which an expired price is
                              removed
                              <br/>(considering that expiring is ON).
                              <br/>Default: 30sec
                            </span>
                          </v-tooltip>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="10" xl="3" lg="4" md="4" sm="5" class="py-0"></v-col>
            </v-row>
            <v-row justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 50px"
              >
                <v-icon :class="darkTheme ? 'title_dark' : 'title_light'" left
                >icon-analytics-23x23
                </v-icon
                >
                Analytics
              </h1>
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="pt-5 mt-5 mb-5 secondary-h1"
              >
                Summary Table
              </h2>
            </v-row>
            <v-row justify="center" class="my-2">
              <v-row
                  justify="space-between"
                  class="settings-switch-row pt-2"
                  style="border-top: 1px solid rgb(255, 255, 255, 0.2)"
              >
                <p
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  Use the actual currency digits
                </p>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="useDigitsField"
                      v-model="useDigitsField"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="
                      fieldStatusIs('useDigitsField', getErrorEnums.LOADING)
                    "
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="
                      fieldStatusIs('useDigitsField', getErrorEnums.SAVED)
                    "
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="
                      fieldStatusIs('useDigitsField', getErrorEnums.DEFAULT)
                    "
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
            </v-row>
            <v-row v-if="isAdmin" justify="center">
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="pt-5 mt-5 mb-5 secondary-h1"
              >
                Logs
              </h2>
            </v-row>
            <v-row v-if="isAdmin" justify="center" class="my-2">
              <v-row
                  justify="space-between"
                  class="settings-switch-row pt-2"
                  style="border-top: 1px solid rgb(255, 255, 255, 0.2)"
              >
                <p
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  Log SSE data.
                </p>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="positionLogs"
                      v-model="positionLogs"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="fieldStatusIs('positionLogs', getErrorEnums.LOADING)"
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="
                      fieldStatusIs('positionLogs', getErrorEnums.SAVED)
                    "
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="
                      fieldStatusIs('positionLogs', getErrorEnums.DEFAULT)
                    "
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
            </v-row>

            <v-row justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 50px"
              >
                <v-icon :class="darkTheme ? 'title_dark' : 'title_light'" left
                >fas fa-chart-line
                </v-icon
                >
                Price Watcher
              </h1>
              <h2
                  :class="darkTheme ? 'lightText' : 'darkText2'"
                  class="pt-5 mt-5 mb-5 secondary-h1"
              >
                Chart
              </h2>
            </v-row>
            <v-row justify="center" class="pb-8 mb-8 my-2">
              <v-row
                  justify="space-between"
                  id="keep-old-data"
                  class="settings-switch-row pt-2"
                  style="border-top: 1px solid rgb(255, 255, 255, 0.2)"
              >
                <p
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  Keep previous time frame data
                </p>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-switch
                      id="keepPreviousTimeFrameData"
                      v-model="keepPreviousTimeFrameData"
                      class="mt-0 pl-1 pt-0"
                      style="height: 30px"
                  ></v-switch>
                  <v-progress-circular
                      class="saving-icon mt-1"
                      v-if="
                      fieldStatusIs(
                        'keepPreviousTimeFrameData',
                        getErrorEnums.LOADING
                      )
                    "
                      size="16"
                      width="2"
                      dense
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-icon
                      v-else-if="
                      fieldStatusIs(
                        'keepPreviousTimeFrameData',
                        getErrorEnums.SAVED
                      )
                    "
                      class="saving-icon-green"
                  >fas fa-check
                  </v-icon
                  >
                  <div
                      v-else-if="
                      fieldStatusIs(
                        'keepPreviousTimeFrameData',
                        getErrorEnums.DEFAULT
                      )
                    "
                      style="width: 16px"
                  ></div>
                  <v-icon v-else class="saving-icon-red" style="height: 23px"
                  >fas fa-times
                  </v-icon
                  >
                </v-row>
              </v-row>
            </v-row>
            <v-row id="pw-warning-time" justify="center" class="pb-8 mb-8 my-2">
              <v-text-field
                  dense
                  id="pricewatcherdataAbsenceWarning"
                  type="number"
                  outlined
                  class="rm-number-arrows settings-number-input"
                  label="Data absence warning (s)"
                  :value="
                  getFilteredSettings.applications.pricewatcher
                    .dataAbsenceWarning
                "
                  @input="
                  ignoreInputChange
                    ? ''
                    : updateSetting(
                        ['applications', 'pricewatcher', 'dataAbsenceWarning'],
                        'dataAbsenceWarning',
                        rules.num
                      )
                "
                  height="20"
                  :rules="[rules.num]"
                  style="max-width: 400px"
              >
                <template v-slot:append>
                  <v-row>
                    <v-col cols="6" style="max-width: 24px" class="py-0 mr-3">
                      <v-progress-circular
                          class="saving-icon mt-1"
                          v-if="
                          fieldStatusIs(
                            'dataAbsenceWarning',
                            getErrorEnums.LOADING
                          )
                        "
                          size="16"
                          width="2"
                          dense
                          color="primary"
                          indeterminate
                      ></v-progress-circular>
                      <v-icon
                          v-else-if="
                          fieldStatusIs(
                            'dataAbsenceWarning',
                            getErrorEnums.SAVED
                          )
                        "
                          class="saving-icon-green mt-1"
                      >fas fa-check
                      </v-icon
                      >
                      <div
                          v-else-if="
                          fieldStatusIs(
                            'dataAbsenceWarning',
                            getErrorEnums.DEFAULT
                          )
                        "
                      ></div>
                      <v-icon v-else class="saving-icon-red mt-1"
                      >fas fa-times
                      </v-icon
                      >
                    </v-col>
                    <v-col cols="4" class="py-0 mr-1">
                      <v-row justify="start">
                        <v-tooltip
                            max-width="300"
                            bottom
                            content-class="text-center"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" class="pt-1"
                            >far fa-question-circle
                            </v-icon
                            >
                          </template>
                          <span class="text-center">
                            Time in seconds (from when a price matched the rule)
                            after which it is considered old. Default: 30sec
                          </span>
                        </v-tooltip>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-text-field>
            </v-row>
            <v-tooltip
                activator="#pw-warning-time"
                :disabled="isNotDesktop"
                class="mt-3 ml-1"
                content-class="tooltipClassBottom"
                nudge-top="10"
                bottom
            >
              <span>
                A warning icon is shown on the chart if no update
                <br/>
                was received after a specified amount of time (in seconds)
              </span>
            </v-tooltip>
          </v-tab-item>
          <v-tab-item class="darkText">
            <v-row justify="center" class="row1">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 30px"
              >
                <v-icon
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="font-size: 21px"
                    left
                >fas fa-lock
                </v-icon
                >
                Login & Password
              </h1>
              <div class="justify-center pt-10">
                <template v-if="showChangePass === false">
                  <v-btn
                      color="primary"
                      @click="showChangePass = true"
                  >
                    <v-icon left>
                      fa fa-key
                    </v-icon>
                    Change Password
                  </v-btn>
                </template>
                <template v-else>
                  <v-form ref="changePassForm">
                    <v-row justify="center" class="mx-2">
                      <v-col
                          cols="12"
                          class="py-0"
                      >
                        <v-text-field
                            id="oldPasswordInput"
                            dense
                            outlined
                            label="Current Password"
                            v-model="changePassword.oldPassword"
                            :type="changePassword.showOldPass ? 'text' : 'password'"
                            @click:append="changePassword.showOldPass = !changePassword.showOldPass"
                            :append-icon="changePassword.showOldPass ? 'fas fa-eye-slash' : 'fas fa-eye'"
                            :rules="[rules.required]"
                            :disabled="savingNewPass"
                        >
                        </v-text-field>
                        <v-text-field
                            id="newPasswordInput"
                            dense
                            outlined
                            label="New Password"
                            v-model="changePassword.newPassword"
                            :type="changePassword.showNewPass ? 'text' : 'password'"
                            @click:append="changePassword.showNewPass = !changePassword.showNewPass"
                            :append-icon="changePassword.showNewPass ? 'fas fa-eye-slash' : 'fas fa-eye'"
                            :rules="[rules.required]"
                            :disabled="savingNewPass"
                        >
                        </v-text-field>
                        <v-text-field
                            id="verifyPasswordInput"
                            dense
                            outlined
                            label="Verify Password"
                            hint="type your new password again"
                            v-model="changePassword.confirmNewPassword"
                            type="password"
                            :rules="[rules.required, rules.newPasswordMatch(changePassword.confirmNewPassword, changePassword.newPassword)]"
                            :disabled="savingNewPass"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="end" class="px-8">
                      <v-btn
                          :disabled="savingNewPass"
                          @click="cancelChangePassword"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                          class="ml-2"
                          color="primary"
                          :disabled="savingNewPass"
                          :loading="savingNewPass"
                          @click="$refs.changePassForm.validate() ? saveNewPassword() : false"
                      >
                        Save
                      </v-btn>
                    </v-row>
                  </v-form>
                </template>
              </div>
              <!--              <h3-->
              <!--                :class="darkTheme ? 'lightText' : 'darkText2'"-->
              <!--                style="padding-top: 53px"-->
              <!--              >-->
              <!--                (Coming soon)-->
              <!--              </h3>-->
            </v-row>
            <v-row justify="center">
              <h1
                  class="titleClass"
                  :class="darkTheme ? 'title_dark' : 'title_light'"
                  style="padding-top: 50px"
              >
                <v-icon
                    :class="darkTheme ? 'title_dark' : 'title_light'"
                    style="font-size: 21px"
                    left
                >fas fa-users-cog
                </v-icon
                >
                Users
              </h1>
            </v-row>
            <v-row v-if="isAdmin" justify="center">
              <v-progress-circular
                  v-if="loadingUsers"
                  :size="20"
                  width="2"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
              <v-col xl="5" lg="9" md="8" sm="10" cols="11">
                <v-data-table
                    :mobile-breakpoint="0"
                    dense
                    hide-default-footer
                    fixed-header
                    :no-data-text="
                    loadingUsersError ? `Couldn't fetch users` : 'No users'
                  "
                    :height="210"
                    class="mt-10 accent stickyHeader"
                    style="
                    z-index: 999 !important;
                    border-radius: 4px;
                    border: 1px solid #47bd96 !important;
                  "
                    :items="users"
                    :headers="usersHeaders"
                    :expanded.sync="expanded"
                    hide-default-header
                    :items-per-page="-1"
                >
                  <template v-slot:item="{ item }">
                    <tr
                        @click="expandRow(item)"
                        :id="
                        $vuetify.theme.dark
                          ? 'dataTableRow_dark'
                          : 'dataTableRow_light'
                      "
                        class="table_Row rowClick"
                    >
                      <td
                          v-for="(header, i) in headersCounter !==
                        usersHeaders.length
                          ? headersCounter
                          : headersCounter - 1"
                          :key="i"
                      >
                        <v-row
                            :justify="
                            usersHeaders[i].value === 'enabled'
                              ? 'center'
                              : 'start'
                          "
                        >
                          <p
                              v-if="headersCounter === 1"
                              :style="`margin-left: 30% !important;`"
                          ></p>
                          <v-icon
                              v-if="
                              usersHeaders[i].value === 'username' &&
                              headersCounter !== usersHeaders.length
                            "
                              :class="
                              expanded.some((el) => el.id === item.id)
                                ? 'red--text pr-1 ml-3'
                                : 'primary--text pr-1 ml-3'
                            "
                              style="font-size: 16px"
                          >
                            {{
                              expanded.some((el) => el.id === item.id)
                                  ? "fas fa-times-circle"
                                  : "fas fa-chevron-circle-down"
                            }}
                          </v-icon>
                          <p
                              v-if="
                              usersHeaders[i].value !== 'enabled' &&
                              usersHeaders[i].value !== 'roles'
                            "
                              class="email-char-lim my-auto"
                              :class="
                              headersCounter < usersHeaders.length &&
                              usersHeaders[i].value === 'username'
                                ? 'ml-1'
                                : 'ml-3'
                            "
                          >
                            {{ item[usersHeaders[i].value] }}
                          </p>
                          <p
                              class="my-auto"
                              v-else-if="usersHeaders[i].value === 'roles'"
                          >
                            {{ getUserRolesText(item.roles) }}
                          </p>
                          <v-switch
                              v-else-if="item.enabled"
                              style="height: 36px"
                              class="mt-0"
                              color="primary"
                              value
                              input-value="true"
                              disabled
                          ></v-switch>
                          <v-switch
                              v-else
                              style="height: 36px"
                              class="mt-0"
                              color="primary"
                              value
                              :input-value="false"
                              disabled
                          ></v-switch>
                        </v-row>
                      </td>
                      <td
                          v-if="headersCounter === usersHeaders.length"
                          class="text-center"
                      >
                        <v-btn icon @click="showEditDialog(item)">
                          <span style="font-size: 28px" class="icon-edit-21x21">
                            <span class="path1 letterSpacing0"></span>
                            <span class="path2"></span>
                          </span>
                        </v-btn>
                        <v-btn icon @click="showDeleteDialog(item)">
                          <span
                              style="font-size: 28px"
                              class="icon-delete-21x21"
                          >
                            <span class="path1 letterSpacing0"></span>
                            <span class="path2"></span>
                          </span>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ item }">
                    <tr
                        v-for="(headerIndex, index) in usersHeaders.length -
                      headersCounter"
                        :key="index"
                        class="expandBackground"
                    >
                      <v-row
                          style="height: 32px"
                          class="expandRowClass_Border mx-0"
                      >
                        <v-col class="py-0" cols="3">
                          <p
                              v-if="item || !item"
                              class="ml-1 my-1"
                              style="font-weight: 600; font-size: 14px"
                          >
                            {{ usersHeaders[index + headersCounter].text }}
                          </p>
                        </v-col>
                        <v-col class="py-0" cols="8">
                          <div
                              v-if="
                              headerIndex < usersHeaders.length - headersCounter
                            "
                          >
                            <p
                                v-if="
                                usersHeaders[index + headersCounter].value !==
                                  'enabled' &&
                                usersHeaders[index + headersCounter].value !==
                                  'roles'
                              "
                                class="ml-1 my-1 pt-1 text-center char-lim"
                                style="font-size: 14px; margin: auto !important"
                            >
                              {{
                                item[usersHeaders[index + headersCounter].value]
                              }}
                            </p>

                            <p
                                v-else-if="
                                usersHeaders[index + headersCounter].value ===
                                'roles'
                              "
                                class="ml-1 my-1 pt-1 text-center char-lim"
                                style="font-size: 14px; margin: auto !important"
                            >
                              {{
                                getUserRolesText(
                                    item[
                                        usersHeaders[index + headersCounter].value
                                        ]
                                )
                              }}
                            </p>
                            <v-switch
                                v-else-if="item.enabled"
                                style="height: 36px; width: 45px !important"
                                class="mt-0 mx-auto"
                                color="primary"
                                value
                                input-value="true"
                                disabled
                            ></v-switch>
                            <v-switch
                                v-else
                                style="height: 36px"
                                class="mt-0 mx-auto"
                                color="primary"
                                value
                                input-value="false"
                                disabledf
                            ></v-switch>
                          </div>
                          <div v-else class="text-center">
                            <v-btn
                                height="32"
                                icon
                                @click="showDeleteDialog(item)"
                            >
                              <span
                                  style="font-size: 28px"
                                  class="icon-delete-21x21"
                              >
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                      <td
                          v-for="header in headersCounter - 1"
                          :key="header"
                          style="border: none"
                      ></td>
                    </tr>
                  </template>
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                    <tr>
                      <th
                          v-for="header in headers.filter((el, index) => {
                            return index + 1 <= headersCounter;
                          })"
                          :key="header.value"
                          style="background: #47bd96; color: white"
                      >
                        <v-row>
                          <v-col height="100%" class="py-0">
                            <v-row
                                :class="
                                  header.value === 'actions' ||
                                  header.value === 'enabled'
                                    ? 'pl-0'
                                    : 'pl-3'
                                "
                                :style="
                                  header.value === 'actions' ||
                                  header.value === 'enabled' ||
                                  headersCounter === 1
                                    ? 'justify-content: center;'
                                    : ''
                                "
                            >
                              <p class="my-0 fullHeight allTableHeadersHover">
                                {{ header.text }}
                              </p>
                            </v-row>
                          </v-col>
                        </v-row>
                      </th>
                    </tr>
                    </thead>
                  </template>
                </v-data-table>
                <v-btn
                    @click="showAddDialog"
                    class="px-1 mt-2"
                    outlined
                    color="primary"
                    small
                >
                  <v-icon style="font-size: 16px" class="mr-2"
                  >fas fa-plus-circle
                  </v-icon
                  >
                  Add user
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center" class="pt-10">
              <v-row
                  justify="space-between"
                  class="settings-switch-row pt-2"
                  style="border-top: 1px solid rgb(255, 255, 255, 0.2)"
              >
                <p
                    :class="darkTheme ? 'lightText' : 'darkText2'"
                    class="ml-4 mb-0"
                >
                  User Profile: {{ selectedProfile.configuration.device }}
                  {{
                    isAdmin && selectedProfile.username
                        ? ` (${selectedProfile.username})`
                        : ""
                  }}
                </p>
                <v-row style="max-width: 88px">
                  <hr width="1"/>
                  <v-btn
                      @click.stop="changeProfile"
                      small
                      icon
                      class="ml-3"
                      style="padding-bottom: 6px"
                  >
                    <span
                        style="font-size: 27px; margin-bottom: 2px"
                        class="icon-edit-21x21"
                    >
                      <span class="path1 letterSpacing0"></span>
                      <span class="path2"></span>
                    </span>
                  </v-btn>
                </v-row>
              </v-row>
            </v-row>
          </v-tab-item>
          <v-tab-item class="darkText">
            <v-row justify="center">
              <notification-settings @refresh="prepareData"/>
            </v-row>
          </v-tab-item>
          <v-tab-item class="darkText">
            <v-row justify="center">
              <tenants/>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
    <v-snackbar
        v-model="changePassword.showSnackbar"
        timeout="4000"
        outlined
        bottom
        left
        :color="!!changePassword.updateSuccess ? 'success':'red accent-2'"
        :class="!!changePassword.updateSuccess ? 'snackbar-panel success-color':'snackbar-panel error-color'"
    >
      <v-row @click="changePassword.showSnackbar = false">
        <v-col cols="2" class="pa-0 text-center">
          <v-icon
              class="flex align-center"
              :class="!!changePassword.updateSuccess ? 'success-color':'error-color'"
              size="1.4em"
          >
            {{ !!changePassword.updateSuccess ? 'far fa-check-circle' : 'fas fa-exclamation-circle' }}
          </v-icon>
        </v-col>
        <v-col cols="10" class="pa-0">
          <div
              class="flex align-center"
              :class="!!changePassword.updateSuccess ? 'success-color':'error-color'"
          >
            {{
              !!changePassword.updateSuccess > 0 ? 'Password successfully changed' : 'Error changing password'
            }}
          </div>
        </v-col>
      </v-row>
    </v-snackbar>
  </div>
</template>
<script>
import {
  LoadingPage,
  DefaultPage,
  ConfirmDialog,
} from "../components/Default-Page-Components";
import NotificationSettings from "@/components/Settings/Notifications/Notifications.vue";
import Tenants from "@/components/Settings/Tenants/Tenants.vue";
import ModePicker from "@/components/Settings/ModePicker.vue";
import {mapMutations, mapGetters, mapActions} from "vuex";
import {defaultSettings, defaultNewUser} from "@/utilities/DefaultObjects";
import {MP3Sounds} from "@/utilities/availibleSounds";
import {SettingsService, UserService} from "@/services/ApiService";
import {SAVING_ENUMS, USER_ROLES} from "@/utilities/enums";
import {events} from "@/plugins/events";

let userInputTimeout;

export default {
  components: {Tenants, ModePicker, DefaultPage, LoadingPage, ConfirmDialog, NotificationSettings},
  name: "Settings",
  data: () => ({
    userFields: [
      {text: "E-mail", value: "email", type: "text-field"},
      {text: "Enabled", value: "enabled", type: "selector"},
      {text: "Password", value: "password", type: "text-field"},
      {text: "Roles", value: "roles", type: "selector"},
      {text: "Username", value: "username", type: "text-field"},
    ],
    edit: false,
    add: false,
    newUserViolations: [],
    showPassword: true,
    expanded: [],
    loadingUsersError: false,
    deletingUser: false, // is used to differentiate between deleting a user and resetting setting
    userToBeDeleted: null,
    enableItems: [
      {value: true, text: "Enabled"},
      {value: false, text: "Disabled"},
    ],
    userRoles: [
      {value: "ROLE_USER", text: "User"},
      {value: "ROLE_ADMIN", text: "Admin"},
    ],
    currentUserEditing: Object.assign({}, defaultNewUser),
    userDialog: false,
    users: [],
    loadingUsers: false,
    USER_ROLES: USER_ROLES,
    ignoreInputChange: false,
    loading: false,
    error: false,
    errorMessage: null,
    usersHeaders: [
      {
        text: "Username",
        value: "username",
      },
      {
        text: "Email",
        value: "email",
      },
      {
        text: "Roles",
        value: "roles",
      },
      {
        text: "Enabled",
        value: "enabled",
      },
      {
        text: "Actions",
        value: "actions",
      },
    ],
    fieldsStatuses: [
      {
        id: "dashboardurl",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "dashboardsecret_key",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "dashboardexp",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "dashboardrefresh_time",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "dashboardnumber",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "ssepingAbsenceLimit",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "stackNotifications",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "logSSEState",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "useDigitsField",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "keepPreviousTimeFrameData",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "positionLogs",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "enableNotifications",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "updateSameTypeNotifications",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "renotify",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "notificationssuccess",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "notificationsinfo",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "notificationserror",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "notificationswarning",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "priceguardpriceOldAfter",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "dataAbsenceWarning",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "priceguarddataExpirationCycle",
        status: SAVING_ENUMS.DEFAULT,
      },
      {
        id: "priceguardremoveExpiredDataAfter",
        status: SAVING_ENUMS.DEFAULT,
      },
    ],
    confirmDialog: false,
    mp3Sounds: MP3Sounds,
    refreshing: false,
    settings: {},
    currentTabItem: {name: "General", icon: "settings", id: 0},
    tabs: null,
    settingsSections: [
      {name: "General", icon: "settings", id: 0},
      {name: "Applications", icon: "apps", id: 1},
      {name: "User", icon: "fas fa-user", id: 2},
    ],
    adminSettingsSections: [
      {name: "Notifications", icon: "fas fa-bullhorn", id: 3},
      {name: "Tenants", icon: "fas fa-briefcase", id: 4},
    ],
    rules: {
      email: (val) => (val.search("@") !== -1 ? true : "Must be an email"),
      required: (val) => {
        if (val.constructor === Array && val.length === 0) return "Required";
        if (!!val || val === 0) {
          return true;
        } else return "Required";
      },
      min: (value) => (value != null && value >= 3) || "Min 3 sec",
      url: (value) =>
          value != null &&
          (value.includes("http") || value.includes("https")) &&
          value.includes("://") &&
          value.includes("dealio.ai"),
      num: (value) => {
        return !Number.isNaN(parseInt(value, 10));
      },
      newPasswordMatch: (value, matchValue) => {
        // return (value === this.changePassword.newPassword) || 'Passwords do not match';
        return (value === matchValue) || 'Passwords do not match';
      },
    },
    valid: true,
    userFormValid: true,
    showChangePass: false,
    changePassword: {
      oldPassword: '',
      showOldPass: false,
      newPassword: '',
      showNewPass: false,
      confirmNewPassword: '',
      showSnackbar: false,
      updateSuccess: true,
    },
    savingNewPass: false,
    passwordsMatch: false,
  }),
  methods: {
    ...mapActions("notifications", ["prepareData"]),
    /**
     * Cancel the change password workflow
     * reset values to their initial state
     */
    cancelChangePassword() {
      this.showChangePass = false;
      this.changePassword = {
        ...this.changePassword,
        oldPassword: '',
        showOldPass: false,
        newPassword: '',
        showNewPass: false,
        confirmNewPassword: '',
      };
    },
    /**
     * Trigger the api call and save the new password. Then reset input fields.
     * Handle errors and success message accordingly using the integrated snackbar.
     */
    async saveNewPassword() {
      const validateInput = this.$refs.changePassForm.validate();
      if (!validateInput) {
        return;
      }
      this.savingNewPass = true;
      const newPassData = {
        id: this.getUserInfo.id,
        oldPassword: this.changePassword.oldPassword,
        newPassword: this.changePassword.newPassword,
        confirmNewPassword: this.changePassword.confirmNewPassword,
      };
      try {
        await UserService.updatePassword(newPassData);
        this.changePassword.updateSuccess = true;
        this.changePassword.showSnackbar = true;
      } catch (error) {
        this.changePassword.updateSuccess = false;
        this.changePassword.showSnackbar = true;
        console.error(error);
      }
      this.savingNewPass = false;
      this.showChangePass = false;
      this.changePassword = {
        ...this.changePassword,
        oldPassword: '',
        showOldPass: false,
        newPassword: '',
        showNewPass: false,
        confirmNewPassword: '',
      };
    },
    saveUser() {
      this.add ? this.saveNewUser() : this.saveEditedUser();
    },
    showAddDialog() {
      this.add = true;
      this.edit = false;
      this.showUserDialog();
    },
    showEditDialog(user) {
      this.currentUserEditing = JSON.parse(JSON.stringify(user));
      this.add = false;
      this.edit = true;
      this.showUserDialog();
    },
    updateSettingStatus(fieldIndex) {
      if (fieldIndex === -1) {
        // if fieldIndex == -1 then the call came from "Reset button"
        this.fieldsStatuses = this.fieldsStatuses.map((field) => {
          field.status = SAVING_ENUMS.DEFAULT;
          return field;
        });
      } else this.fieldsStatuses[fieldIndex].status = SAVING_ENUMS.SAVED;
    },
    updateSettingsRemoteFailed(
        reverseOnCatch = false,
        fieldIndex = 0,
        reverseArgs = {}
    ) {
      if (this.confirmDialog !== false) this.confirmDialog = false;
      if (reverseOnCatch)
        this.updateSpecificSetting({
          sections: reverseArgs.sections,
          value: reverseArgs.oldValue,
        });
      if (fieldIndex === -1) {
        this.fieldsStatuses = this.fieldsStatuses.map((field) => {
          field.status = null;
          return field;
        });
      } else this.fieldsStatuses[fieldIndex].status = null;
    },
    changeProfile() {
      events.$emit("edit-settings-profile");
    },
    parseViolations(data) {
      if (data.violations) {
        let passwordViolationsParsed;
        let passwordViolations = data.violations.find(
            (el) => el.fieldName === "password"
        );
        if (passwordViolations) {
          passwordViolationsParsed = passwordViolations.message.split(",");
        }
        return data.violations.reduce((final, next) => {
          if (next.fieldName === "password") {
            final = final.concat(passwordViolationsParsed);
          } else final.push(next.message);
          return final;
        }, []);
      } else {
        return [data.message];
      }
    },
    expandRow(item) {
      if (this.expanded.length) {
        if (this.expanded[0].id === item.id) {
          this.expanded.pop();
        } else {
          this.expanded.pop();
          this.expanded.push(item);
        }
      } else {
        this.expanded.push(item);
      }
    },
    confirmationEvent(event) {
      this.confirmDialog = event;
    },
    showDeleteDialog(user) {
      this.deletingUser = true;
      this.userToBeDeleted = user;
      this.confirmDialog = true;
    },
    getUserRolesText(roles) {
      let text = "";
      roles.forEach((role, i) => {
        if (i !== 0) text += ", ";

        text += this.userRoles.find((el) => el.value === role).text;
      });
      return text;
    },
    saveEditedUser() {
      if (this.$refs.userForm.validate()) {
        let params = JSON.parse(JSON.stringify(this.currentUserEditing));
        let id = params.id;
        delete params.id;
        if (params.hasOwnProperty("password") && !params.password.length)
          delete params.password;

        UserService.put(id, this.currentUserEditing)
            .then(() => {
              this.$notifier.info("User edited successfully.");
              this.refreshUsers();
              this.userDialog = !this.userDialog;
            })
            .catch((error) => {
              let notifyMessage;
              if (error.message.search("400") !== -1) {
                this.newUserViolations = this.parseViolations(
                    error.response.data
                );
              } else {
                notifyMessage = `Oops! Something went wrong!'`;
                this.$notifier.error(notifyMessage, {error: error});
              }
            });
      }
    },
    saveNewUser() {
      if (this.$refs.userForm.validate()) {
        UserService.post(this.currentUserEditing)
            .then(() => {
              this.$notifier.info("New user added");
              this.refreshUsers();
              this.userDialog = !this.userDialog;
            })
            .catch((error) => {
              let notifyMessage;
              if (error.message.search("400") !== -1) {
                this.newUserViolations = this.parseViolations(
                    error.response.data
                );
              } else {
                notifyMessage = `Oops! Couldn't add user '${this.currentUserEditing.username}'`;
                this.$notifier.error(notifyMessage, {error: error});
              }
            });
      }
    },
    showUserDialog() {
      this.newUserViolations = [];
      this.userDialog = true;
      this.$nextTick(() => {
        this.$refs.userForm.resetValidation();
      });
    },
    deleteUser(confirm) {
      if (confirm) {
        UserService.delete(this.userToBeDeleted.id)
            .then(() => {
              this.confirmDialog = false;
              this.$notifier.info(
                  `User ${this.userToBeDeleted.username} deleted`
              );
              this.refreshUsers();
            })
            .catch((error) => {
              this.confirmDialog = false;
              this.$notifier.error(
                  `Couldn't delete user ${this.userToBeDeleted.username} please try again`,
                  {error: error}
              );
            });
      } else this.confirmDialog = false;
    },
    refreshUsers() {
      UserService.get()
          .then((response) => {
            this.users = response.data;
          })
          .catch((error) => {
            this.$notifier.error("Couldn't refresh users please reload Dealio", {
              error: error,
            });
          });
    },
    getUsers() {
      this.loadingUsers = true;
      UserService.get()
          .then((response) => {
            if (this.loadingUsersError) this.loadingUsersError = false;
            this.loadingUsers = false;
            this.users = response.data;
          })
          .catch((error) => {
            this.loadingUsersError = true;
            this.loadingUsers = false;
            this.$notifier.error("Couldn't load users information", {
              error: error,
            });
          });
    },
    executeShortCuts() {
      setTimeout(() => {
        if (this.$route.query && this.$route.query.userSettings) {
          this.tabs = 2;
          this.currentTabItem = Object.assign(
              {},
              this.settingsSections.find((el) => el.name === "User")
          );
        }
      }, 700);
    },
    postNewSetting(options = null) {
      SettingsService.post(
          options && options.params ? options.params : defaultSettings
      )
          .then((response) => {
            if (!response.data) {
              if (this.isAdmin)
                console.error("No data in response when posting new settings.");
              return;
            }

            if (options && options.fieldIndex) {
              this.updateSettingStatus(options.fieldIndex);
            }

            // Save the currentSettingsProfileId
            this.$emit("mutate-selected-profile", response.data);
            this.$emit("mutate-settings-profile-exists", true);
            localStorage.setItem("currentSettingsProfileId", response.data.id);
            this.loading = false;
          })
          .catch((error) => {
            this.$emit("mutate-settings-profile-exists", false);
            if (!options) this.error = true;
            this.errorMessage = error.message;
            this.loading = false;
            this.$notifier.error(
                "Couldn't create a new settings profile. Please reload Dealio",
                {error: error}
            );
          });
    },
    fetchSettings() {
      this.error = false;
      this.loading = true;
      SettingsService.get()
          .then((response) => {
            if (response.data.length) {
              this.$emit("mutate-settings-profile-exists", true);
              this.$emit("set-new-settings", response.data[0].configuration);
              localStorage.setItem(
                  "currentSettingsProfileId",
                  response.data[0].id
              );
              this.loading = false;
              this.executeShortCuts();
            } else {
              this.postNewSetting();
              this.updateSettings(defaultSettings);
              this.executeShortCuts();
            }
          })
          .catch((error) => {
            this.$emit("mutate-settings-profile-exists", false);
            if (error.message.search("500") !== -1) {
              this.loading = false;
              this.error = false;
            } else {
              this.loading = false;
              this.error = true;
              this.errorMessage = error.message;
            }
            this.updateSettings(defaultSettings);
            this.executeShortCuts();
            console.log(error);
            this.$notifier.error(
                "Couldn't fetch application settings, reload Dealio. Otherwise, default settings will be applied",
                {error: error}
            );
          });
    },
    fieldStatusIs(id, status) {
      return this.fieldsStatuses.find((el) => el.id === id).status === status;
    },
    updateSettingsRemote(
        params,
        fieldIndex = -1,
        reverseOnCatch,
        reverseArgs,
        otherOptions
    ) {
      let recursive = typeof otherOptions == "object" && otherOptions.recursive;

      let profileId = parseInt(
          localStorage.getItem("currentSettingsProfileId"),
          10
      );
      if (!profileId && profileId !== 0) return;

      let requestStatus = "200";

      SettingsService.put(profileId, params)
          .then(() => {
            if (this.confirmDialog !== false) this.confirmDialog = false;
            this.updateSettingStatus(fieldIndex);
          })
          .catch((error) => {
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1 &&
                !recursive
            ) {
              requestStatus = "404";
              // Get the configuration for the current type of device
              return SettingsService.getMe({
                params: {
                  device:
                      localStorage.getItem("selected-device-type") || "Desktop",
                },
              });
            }

            this.updateSettingsRemoteFailed(
                reverseOnCatch,
                fieldIndex,
                reverseArgs
            );

            console.error(error);
            this.$notifier.error(
                "Couldn't update application settings, please try again",
                {error: error}
            );
          })
          .then((response) => {
            // DESCRIPTION:
            // In this part the new currentSettingsProfileId is set & the remote settings are updated
            // "recursive" means that updateAppSettingsRemotely was called recursively to update remote & local settings
            // The reason for this is not avoid code duplication. You can see the updateAppSettingsRemotely() being called again below
            if (requestStatus === "404" && response.data && !recursive) {
              localStorage.setItem(
                  "currentSettingsProfileId", // TODO see where & how currentSettingsProfileId is used
                  response.data.id
              );

              this.updateSettingsRemote(
                  params,
                  fieldIndex,
                  reverseOnCatch,
                  reverseArgs,
                  {recursive: true}
              );
            }
          })
          .catch((error) => {
            // DESCRIPTION:
            // In this part a new pageState config is being created & currentSettingsProfileId is set inside the postNewSetting()
            // CASE:
            // This catches a case where "SettingsService.getMe" above returned an error
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1
            ) {
              this.postNewSetting({params, fieldIndex});
            } else {
              console.log(error);
            }
          });
    },
    addItem(item, index) {
      this.currentTabItem = Object.assign({}, item);
      this.tabs = index;
    },
    useSoundAs(eventName, sound) {
      this.updateEventSound({eventName: eventName, sound: sound});
    },
    resetCurrentSettings(confirmation) {
      // ignore any change on the text-fields (do not update remote)
      this.ignoreInputChange = true;
      if (confirmation) {
        this.refreshing = true;
        if (this.isAdmin) this.$refs.dashboardForm.reset();
        this.updateSettings(defaultSettings);
        this.updateSettingsRemote(this.getFilteredSettings);
        this.refreshing = false;
      }
      this.confirmDialog = !this.confirmDialog;
      // unignore input change
      this.ignoreInputChange = false;
    },
    updateSwitchSetting(locationArray, id) {
      let value = this.getSpecificSetting({
        section: locationArray[0],
        innerSection: locationArray[1],
      })[locationArray[locationArray.length - 1]];
      let mutatedValue = !value;
      this.updateSpecificSetting({
        sections: JSON.parse(JSON.stringify(locationArray)),
        value: mutatedValue,
      });

      let fieldIndex = this.fieldsStatuses.findIndex((el) => el.id === id);
      this.fieldsStatuses[fieldIndex].status = SAVING_ENUMS.LOADING;
      this.updateSettingsRemote(this.getFilteredSettings, fieldIndex);
    },

    updateSetting(locationArr, id, rule = null) {
      clearTimeout(userInputTimeout);
      userInputTimeout = setTimeout(() => {
        // SECTION 1 : FIELD STATUS
        let fieldIndex = this.fieldsStatuses.findIndex(
            (el) => el.id === id
        );
        this.fieldsStatuses[fieldIndex].status = SAVING_ENUMS.LOADING;

        // SECTION 2 : RULES CHECK + SAVING LOCALLY & REMOTELY
        let textField = document.getElementById(
            locationArr[locationArr.length - 2] +
            locationArr[locationArr.length - 1]
        );

        let check = rule == null ? true : rule(textField.value);
        if (typeof check == "boolean" && check) {
          this.updateSpecificSetting({
            sections: JSON.parse(JSON.stringify(locationArr)),
            value:
                textField.type === "number"
                    ? parseInt(textField.value)
                    : textField.value,
          });
          this.updateSettingsRemote(this.getFilteredSettings, fieldIndex);
        } else {
          // CHANGE STATUS RULE NOT PASSSED
          this.fieldsStatuses[fieldIndex].status = null;
        }
      }, 150);
    },
    ...mapMutations(["updateSpecificSetting"]),
    ...mapMutations(["updateSettings"]),
    ...mapMutations(["updateEventSound"]),
  },
  computed: {
    passwordHint() {
      if (
          !this.currentUserEditing.password ||
          (this.editing &&
              (this.currentUserEditing.password == null ||
                  (typeof this.currentUserEditing.password === 'string' &&
                      !this.currentUserEditing.password.length)))
      ) {
        return "Fill to change password";
      } else
        return typeof this.currentUserEditing.password == "string" &&
        this.currentUserEditing.password.length < 8
            ? "Weak password"
            : "";
    },
    textTheme() {
      return darkTheme ? "lightText" : "darkText2";
    },
    headersCounter() {
      switch (true) {
        case this.$vuetify.breakpoint.width < 580:
          return 2;
        case this.$vuetify.breakpoint.width < 680:
          return 3;
        case this.$vuetify.breakpoint.width < 783:
          return 4;
        default:
          return this.usersHeaders.length;
      }
    },
    confirmationDialogText() {
      if (this.deletingUser)
        return `Delete user '${this.userToBeDeleted.username}' ?`;
      else return "Do you want to reset all settings ?";
    },
    confirmationEventFunction() {
      if (this.deletingUser) return this.deleteUser;
      else return this.resetCurrentSettings;
    },
    getErrorEnums() {
      return SAVING_ENUMS;
    },
    darkTheme() {
      return this.$vuetify.theme.dark;
    },
    renotify: {
      get() {
        return this.getFilteredSettings.general.notifications.renotify;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "renotify"],
            "renotify"
        );
      },
    },
    enableNotifications: {
      get() {
        return this.getFilteredSettings.general.notifications.enable;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "enable"],
            "enableNotifications"
        );
      },
    },
    updateSameTypeNotifications: {
      get() {
        return this.getFilteredSettings.general.notifications.updateSameType;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "updateSameType"],
            "updateSameTypeNotifications"
        );
      },
    },
    stackNotifications: {
      get() {
        return this.getFilteredSettings.general.notifications.stack;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "stack"],
            "stackNotifications"
        );
      },
    },
    logSSEState: {
      get() {
        return this.getFilteredSettings.general.sse.logSSEState;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "sse", "logSSEState"],
            "logSSEState"
        );
      },
    },
    useDigitsField: {
      get() {
        return this.getFilteredSettings.applications.analytics.useDigitsField;
      },
      set(value) {
        this.updateSwitchSetting(
            ["applications", "analytics", "useDigitsField"],
            "useDigitsField"
        );
      },
    },
    keepPreviousTimeFrameData: {
      get() {
        return this.getFilteredSettings.applications.pricewatcher
            .keepPreviousTimeFrameData;
      },
      set(value) {
        this.updateSwitchSetting(
            ["applications", "pricewatcher", "keepPreviousTimeFrameData"],
            "keepPreviousTimeFrameData"
        );
      },
    },
    positionLogs: {
      get() {
        return this.getFilteredSettings.applications.analytics.positionLogs;
      },
      set(value) {
        this.updateSwitchSetting(
            ["applications", "analytics", "positionLogs"],
            "positionLogs"
        );
      },
    },
    notificationssuccess: {
      get() {
        return this.getFilteredSettings.general.notifications.success;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "success"],
            "notificationssuccess"
        );
      },
    },
    notificationsinfo: {
      get() {
        return this.getFilteredSettings.general.notifications.info;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "info"],
            "notificationsinfo"
        );
      },
    },
    notificationserror: {
      get() {
        return this.getFilteredSettings.general.notifications.error;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "error"],
            "notificationserror"
        );
      },
    },
    notificationswarning: {
      get() {
        return this.getFilteredSettings.general.notifications.warning;
      },
      set(value) {
        this.updateSwitchSetting(
            ["general", "notifications", "warning"],
            "notificationswarning"
        );
      },
    },
    getEventNames() {
      return this.getEventsNames.map((el) => {
        return {original: el, filtered: el.replace(/_/g, " ")};
      });
    },
    getAvailableEvents() {
      return this.getEventsAndSounds.map((el) => {
        return {event: el[0].replace(/_/g, " "), sound: el[1]};
      });
    },
    getFilteredSettings() {
      if (
          this.getSettings === undefined ||
          !Object.keys(this.getSettings).length
      ) {
        return defaultSettings;
      } else {
        return this.getSettings;
      }
    },
    ...mapGetters(["getSettings"]),
    ...mapGetters(["getEventsAndSounds"]),
    ...mapGetters(["getEventsNames"]),
    ...mapGetters(["getSpecificSetting"]),
    ...mapGetters(["getUserInfo", "isAdmin"]),
  },
  props: {
    settingsProfileExists: {
      type: Boolean,
      default: false,
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeY: {
      type: Number,
      default: 0,
    },
    showUserSettings: {
      type: Boolean,
      default: false,
    },
    selectedProfile: {
      type: Object,
      default: () => {
      },
    },
  },
  // created() {
  //   if (!this.settingsProfileExists) {
  //     this.fetchSettings();
  //   } else {
  //     this.loading = false;
  //     this.executeShortCuts();
  //   }
  // },
  mounted() {
    this.executeShortCuts();
  },
  beforeRouteLeave(to, from, next) {
    document.getElementById("htmlId").style.overflowY = "auto";
    next();
  },
  watch: {
    showUserSettings() {
      this.tabs = 2;
      this.currentTabItem = Object.assign(
          {},
          this.settingsSections.find((el) => el.name === "User")
      );
    },
    confirmDialog(val) {
      // clear confirmation dialog from "deleting a user" status when its closed
      if (!val) {
        setTimeout(() => {
          this.deletingUser = false;
        }, 200);
      }
    },
    userDialog(val) {
      if (!val) {
        this.currentUserEditing = Object.assign({}, defaultNewUser);
      }
    },
    tabs(val) {
      this.prepareData();
      if (val === 2 && this.isAdmin) {
        this.getUsers();
      }
    },
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.v-tabs-customClass .v-item-group + .v-window {
  background: transparent;
}

/* .v-tabs-customClass .v-slide-group {
  border-bottom: 1px solid #adadb2 !important;
} */
.pageBackground_dark {
  background: #262b2e;
  height: inherit;
}

.pageBackground_light {
  background: #fff;
  height: inherit;
}

/* background of the v-text label */
.dashboardTabItem .v-label.v-label--active.theme--light {
  background: transparent !important;
}

#text-fields .v-label.v-label--active.theme--light {
  background: transparent !important;
}
</style>
<style src="../css/utilities/settings.css"></style>
<style scoped src="../css/utilities/scoped/settings.css"></style>
<style lang="scss" scoped src="../css/dealio.scss"/>
